import {
    OrganizationMemberAccessLogView,
    OrganizationMemberAccessLogViewSchema,
} from "@common/types/views/organizationMemberAccessLogView";
import { createDefaultMemberAccessLogView } from "@components/organizationView/memberAccessLog/DefaultMemberAccessLogView";
import { ORGANIZATION_USER_CACHE_KEYS } from "../useOrganizationUserCache";
import { useViewStore } from "./useViewStore";

export function useMemberAccessLogViewStore() {
    return useViewStore<OrganizationMemberAccessLogView>({
        defaultView: createDefaultMemberAccessLogView(),
        viewSchema: OrganizationMemberAccessLogViewSchema,
        cacheKey:
            ORGANIZATION_USER_CACHE_KEYS.ORGANIZATION_MEMBER_ACCESS_LOG_PAGE_VIEW_CACHE_KEY,
    });
}
